import { useSearchParameter } from 'framework/routing';
import { APPLICATION_URL } from 'infrastructure/constants';

const AZURE_ACCESS_CODE = 'code';
const AZURE_ACCESS_ERROR = 'error';

export const ONE_CLICK_PATH = '/signin/oneclick';
const OAUTH_AZURE_PATH = '/oauth/azure';
export const AZURE_LOGOUT_PATH = `${OAUTH_AZURE_PATH}/logout`;
export const AZURE_CALLBACK_PATH = `${OAUTH_AZURE_PATH}/callback`;
export const AZURE_CALLBACK_URL = process.env.REACT_APP_DAVINCI_FRONTEND_AZURE_CALLBACK;

const AZURE_TENANT_ID = process.env.REACT_APP_DAVINCI_FRONTEND_AZURE_TENANT_ID;
const AZURE_LOGOUT_URL = process.env.REACT_APP_DAVINCI_FRONTEND_AZURE_LOGOUT_URL;
const AZURE_CLIENT_ID = process.env.REACT_APP_DAVINCI_FRONTEND_AZURE_CLIENT_ID;

export const useAuthenticationUrl = () => {
  const getAzureAuthUrl = () => {
    return (
      'https://login.microsoftonline.com/' +
      `${AZURE_TENANT_ID}/` +
      'oauth2/authorize?' +
      'response_type=code&' +
      `redirect_uri=${encodeURIComponent(APPLICATION_URL || '')}` +
      `${encodeURIComponent(AZURE_CALLBACK_URL || '')}&` +
      'response_mode=query&' +
      `client_id=${AZURE_CLIENT_ID}`
    );
  };

  const getAzureLogoutUrl = () => {
    return `${AZURE_LOGOUT_URL}?post_logout_redirect_uri=${encodeURIComponent(APPLICATION_URL || '')}`;
  };

  return {
    getAzureAuthUrl,
    getAzureLogoutUrl,
  };
};

export const useAzureAccessCode = () => useSearchParameter(AZURE_ACCESS_CODE);

export const useAzureAccessError = () => useSearchParameter(AZURE_ACCESS_ERROR);
